module.exports = __webpack_public_path__ + "img/img_app_btm_01_feature1.514c35ac.png";